import {groupEditors} from "../../common/group-editors";

export const groupItemEditors = (editors) => ({
    ...groupEditors(editors),

    forceSave: editors?.some((e) => e?.forceSave),
});
